const state = () => ({
    user: {
        name: 'John Doe',
        email: 'jdoe@example.com',
    },
    tenant: {
        name: 'Default Tenant',
    },
    routes: [],
    tenants: [],
    allRoles: undefined,
    allUsers: {},
});

const getters = {
};

const actions = {
    async loadRoles({ commit }) {
        const roles = await this.apiClient.getJson('/api/v1/roles');
        commit('setAllRoles', roles);
    },
    async getRole({ state, commit }, roleId) {
        roleId = roleId.toLowerCase();
        if (!state.allRoles) {
            const roles = await this.apiClient.getJson('/api/v1/roles');
            commit('setAllRoles', roles);
        }
        if (state.allRoles[roleId] === undefined) {
            const role = await this.apiClient.getJson(`/api/v1/role/${roleId}`);
            commit('setRole', role);
        }
        return state.allRoles[roleId];
    },
    async setAuthenticationStatus({ commit }, status) {
        commit('setUser', status.user);
        commit('setTenants', status.tenants);
        commit('setTenant', status.tenants.find(x => x.id === status.currentTenantId));
        commit('setRoutes', status.routes);
    },
    async getAuthenticationStatus({ commit }) {
        const info = await this.apiClient.getAuthenticationStatus();
        if (!info.success) {
            commit('setUser', {});
            commit('setTenants', []);
            commit('setTenant', {});
            commit('setRoutes', []);
            return;
        }
        const status = info;
        commit('setUser', status.user);
        commit('setTenants', status.tenants);
        commit('setTenant', status.tenants.find(x => x.id === status.currentTenantId));
        commit('setRoutes', status.routes);
    },
    async switchTenant({ commit }, tenantId) {
        var tenant = await this.apiClient.switchTenant(tenantId);
        commit('setTenant', tenant);
    },
};

const mutations = {
    setUser(state, user) {
        state.user = user;
    },
    setRoutes(state, routes) {
        state.routes = routes;
    },
    setTenants(state, tenants) {
        state.tenants = tenants;
    },
    setTenant(state, tenant) {
        state.tenant = tenant;
    },
    signIn(state, user) {
        state.user = user;
    },
    signOut(state) {
        state.user = null;
        state.tenant = null;
        state.tenants = [];
        state.routes = [];
    },
    signInComplete() {
        // do nothing
    },
    setAllRoles(state, roles) {
        const roleMap = (roles || []).reduce((p, c) => { p[c.id.toLowerCase()] = c; return p; }, {});
        state.allRoles = roleMap;
    },
    setRole(state, role) {
        if (!state.allRoles) {
            state.allRoles = {};
        }
        state.allRoles[role.id] = role.name;
    }
    // setRoutes(state, routes) {
    //     const cur = router.currentRoute.value;
    //     router.removeRoute('adminRoot');
    //     router.addRoute(mapRoutes(routes));
    //     router.replace(cur.fullPath);
    //     state.routes = routes;
    // },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};